"use client";

import HeaderBackground from "@/components/ui/header-background";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import { useSearchProductsData } from "@/views/search/hooks/useSearchProductsData";
import { useStore } from "@/hooks/system/useStore";
import { useTranslations } from "next-intl";
import { observer } from "mobx-react-lite";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import clsx from "clsx";

const SearchHeader = () => {
  const { searchProducts, isLoading } = useSearchProductsData();
  const { selectedFilters } = useStore("search");
  const t = useTranslations();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  if (!searchProducts || isLoading) return <></>;

  return (
    <>
      <HeaderBackground type="black" />
      <Container>
        <div className={clsx(S.headerContainer, { [S["headerContainer--empty"]]: !searchProducts.total })}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <span className={S.headerTitle}>
            {searchProducts.total
              ? t("resultsFor", {
                  count: searchProducts.total,
                  q: selectedFilters.q || "",
                })
              : t("search")}
          </span>
        </div>
      </Container>
    </>
  );
};

export default observer(SearchHeader);
